const styles = theme => ({
  addNewFieldContainer: {
    margin: theme.spacing(1)
  },
  fieldNameContainer: {
    marginBottom: theme.spacing(3)
  },
  leftFieldNameContainer: {
    width: "40%",
    marginRight: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginRight: theme.spacing(0)
    }
  },
  rightFieldNameContainer: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  allowUserText: {
    color: theme.palette.alt.main
  },
  freeTextDisabled: {
    opacity: "24%"
  },
  freeTextTitle: {
    color: theme.palette.primary.default
  },
  createUserResponseContainerDisabled: {
    opacity: "24%",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5)
    }
  },
  createUserResponseContainer: {
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5)
    }
  },
  createUserTitle: {
    color: theme.palette.primary.default
  },
  fieldOptionContainer: {
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  fieldOptionChildContainer: {
    width: "35%",
    borderBottom: "1px solid #DAE2D9",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  grayText: {
    color: "#00000061"
  },
  buttonsContainer: {
    paddingRight: theme.spacing(2),
    borderTop: `1px solid #DAE2D9`,
    width: "100%",
    padding: `${theme.spacing(1)}px 0`
  },
  removeButton: {
    color: [theme.palette.warning.main, "!important"]
  },
  saveButton: {
    marginLeft: theme.spacing(1)
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },
  cancelButton: {
    color: [theme.palette.primary.default, "!important"]
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/AdditionalField/styles.js